import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEO, { buildBreadcrumbSchema } from '@/components/SEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const securitySchema = [
  buildBreadcrumbSchema([
    { name: 'Home', href: '/' },
    { name: 'Security', href: '/security' },
  ]),
  {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Security at Fore Capital',
  url: `${SITE_URL}/security`,
  description: 'Enterprise-grade security at Fore Capital. Tokenization, encryption, PCI DSS compliance, and SOC 2 certification built into every layer of our payment infrastructure.',
  },
];

export default function Security() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]" style={{ fontFamily: "'Google Sans Flex', sans-serif" }}>
      <SEO
        title="Security | Fore Capital | Enterprise-Grade Protection"
        description="Enterprise-grade security at Fore Capital. Tokenization, encryption, PCI DSS compliance, and SOC 2 certification built into every layer of our payment infrastructure."
        keywords="payment security, PCI DSS, SOC 2, tokenization, encryption, fraud prevention"
        pathname="/security"
        schema={securitySchema}
      />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="bg-[#122852] py-20 px-5 md:px-[75px]">
          <div className="max-w-[1400px] mx-auto">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 mb-6" aria-label="Breadcrumb">
              <a
                href="/"
                className="text-white/40 text-[11px] uppercase tracking-[0.18em] hover:text-white/70 transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Home
              </a>
              <span className="text-white/25 text-[11px]">/</span>
              <span
                className="text-[#d3b366] text-[11px] uppercase tracking-[0.18em]"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                Security
              </span>
            </nav>
            <p
              className="text-[#d3b366] text-[10px] uppercase tracking-[0.25em] font-medium mb-4"
              style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
            >
              Security
            </p>
            <h1
              className="text-white text-3xl md:text-4xl lg:text-[48px] font-light leading-[1.1]"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Security at Every Layer.
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="py-28 px-5 md:px-[75px]">
          <div className="max-w-[900px] mx-auto text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-[#061e45]/5 rounded-full mx-auto mb-8">
              <i className="ri-shield-check-line text-[#125694] text-2xl" />
            </div>
            <h2
              className="text-[#061e45] text-2xl md:text-3xl font-light mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Enterprise-Grade Security
            </h2>
            <p
              className="text-[#1A1A1A]/60 text-base leading-relaxed max-w-xl mx-auto mb-10"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              From tokenization and encryption to PCI DSS compliance and SOC 2 certification, we build security into every layer of our infrastructure — not as an afterthought.
            </p>
            <p
              className="text-[#1A1A1A]/40 text-[15px]"
              style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
            >
              This page is coming soon. For security inquiries, please contact us at{' '}
              <a href="mailto:security@forecapital.io" className="text-[#a8894a] hover:underline cursor-pointer">
                security@forecapital.io
              </a>
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}